export default __webpack_public_path__ + "./fonts/MinimizeIcon.de235e0e.svg";